import {useIntlTyped} from "../../../lib/useIntlTyped.js";
import {localeMessage} from "../i18n.js";
import {SHOPIFY_RULE, SHOPEE_RULE, LAZADA_RULE, AKULAKU_RULE} from "../../../lib/priceRule.js";
export const useRulesByChannelId = () => {
  const {formatMessage, formatMessageMock} = useIntlTyped(localeMessage);
  const getRulesByChannelId = (channelId, code) => {
    code = code || "IDR";
    if (channelId === "TOKOPEDIA_ID") {
      return [
        {
          required: true,
          type: "number",
          min: code === "MYR" ? 0.01 : 100,
          max: code === "MYR" ? 1e6 : 1e8,
          message: formatMessage({
            id: `tokopediaPriceLimit`
          }, {
            min: code === "MYR" ? 0.01 : 100,
            max: code === "MYR" ? 1e6 : 1e8
          })
        }
      ];
    }
    if (channelId === "BUKALAPAK_ID") {
      return [
        {
          required: true,
          type: "number",
          min: code === "MYR" ? 0.01 : 1,
          max: code === "MYR" ? 1e6 : 1e9,
          message: formatMessage({
            id: `bukalapakPriceLimit`
          }, {
            min: code === "MYR" ? 0.01 : 1,
            max: code === "MYR" ? 1e6 : 1e9
          })
        }
      ];
    }
    if (channelId === "TIKTOK_ID") {
      if (code == "IDR") {
        return [
          {
            required: true,
            type: "number",
            min: 100,
            max: 1e8,
            message: formatMessage({
              id: `TikTokPriceLimit`
            }, {
              min: 100,
              max: 1e8
            })
          }
        ];
      } else {
        return [];
      }
    }
    if (channelId === "TIKI_ID") {
      return [
        {
          required: true,
          type: "number",
          min: 1e3,
          max: 2e7,
          message: formatMessage({
            id: `tikiPriceLimit`
          }, {
            min: 1e3,
            max: 2e7
          })
        }
      ];
    }
    if (channelId === "JD_ID") {
      return [
        {
          required: true,
          type: "number",
          min: code === "MYR" ? 0.01 : 100,
          max: code === "MYR" ? 1e6 : 1e9,
          message: formatMessage({
            id: `jdPriceLimit`
          }, {
            min: code === "MYR" ? 0.01 : 100,
            max: code === "MYR" ? 1e6 : 1e9
          })
        }
      ];
    }
    if (channelId === "SHOPEE_ID") {
      const min = SHOPEE_RULE[code]?.min || 0;
      const max = SHOPEE_RULE[code]?.max || 1e9;
      return [
        {
          required: true,
          type: "number",
          min,
          max,
          message: formatMessage({
            id: `shopeePriceLimit`
          }, {
            min,
            max
          })
        }
      ];
    }
    if (channelId === "SHOPIFY_ID") {
      const min = SHOPIFY_RULE[code]?.min || 0;
      const max = SHOPIFY_RULE[code]?.max || 1e9;
      return [
        {
          required: true,
          type: "number",
          min,
          max,
          message: formatMessage({
            id: `shopifyPriceLimit`
          }, {
            min,
            max
          })
        }
      ];
    }
    if (channelId === "BLIBLI_ID") {
      return [
        {
          required: true,
          type: "number",
          min: code === "MYR" ? 0.01 : 1,
          max: code === "MYR" ? 1e9 : 1e9,
          message: formatMessage({
            id: `blibliPriceLimit`
          }, {
            min: code === "MYR" ? 0.01 : 1,
            max: code === "MYR" ? 1e9 : 1e9
          })
        }
      ];
    }
    if (channelId === "LAZADA_ID") {
      const min = LAZADA_RULE[code]?.min || 0;
      const max = LAZADA_RULE[code]?.max || 1e9;
      return [
        {
          required: true,
          type: "number",
          min,
          max,
          message: formatMessage({
            id: `lazadaPriceLimit`
          }, {
            min,
            max
          })
        }
      ];
    }
    if (channelId === "ZALORA_ID") {
      return [
        {
          required: true,
          type: "number",
          min: 0.01,
          max: 1e7,
          message: formatMessage({
            id: `priceRangeOfChannel`
          }, {
            channel: "Zalora",
            min: 0.01,
            max: 1e7
          })
        }
      ];
    }
    if (channelId === "AKULAKU_ID") {
      const min = AKULAKU_RULE[code]?.min;
      const max = AKULAKU_RULE[code]?.max || 1e9;
      if (min) {
        return [
          {
            required: true,
            type: "number",
            min,
            max,
            message: formatMessage({
              id: `priceRangeOfChannel`
            }, {
              channel: "Akulaku",
              min,
              max
            })
          }
        ];
      }
      return [
        {
          required: true,
          type: "number",
          min: 0.5,
          max: 1e8,
          message: formatMessage({
            id: `priceRangeOfChannel`
          }, {
            channel: "Akulaku",
            min: 0.5,
            max: 1e8
          })
        }
      ];
    }
    if (channelId === "JD_TH") {
      return [
        {
          required: true,
          type: "number",
          min: 1,
          max: 999999999,
          message: formatMessage({
            id: `priceRangeOfChannel`
          }, {
            channel: "JD.TH",
            min: 1,
            max: 999999999
          })
        }
      ];
    }
    return [];
  };
  return {getRulesByChannelId};
};
